import { ApprovalMode } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'
import { useTranslation } from 'react-i18next'

// 生 ChakraBadge を import できるのは lint の許可リスト (@ebalance/eslint-config の
// react-app.cjs) に載ったカテゴリカル専用部品だけ。 本ファイルはその 1 つ。
import { ChakraBadge } from '@enechain/ecloud-designsystem'

/**
 * 承認モード → 識別色 + ラベル。
 *
 * 承認モードは承認フロー設定の**種別**であって進行度でも良し悪しでもないため、
 * semantic status ではなくカテゴリカル配色を使う (= 「自動 = positive」 のような
 * 価値判断を色に持ち込まない)。 色マップをこの部品に閉じ込め、 色を外から渡す口は
 * 公開しない。
 *
 * UNSPECIFIED (= 未設定) だけは設定の種別ではなく「設定されていないこと」 なので、
 * 他 3 値と性質が違う neutral 相当として灰で表す。
 */
const APPROVAL_MODE_BADGE: Record<
  ApprovalMode,
  { colorPalette: string; labelKey: string }
> = {
  [ApprovalMode.UNSPECIFIED]: {
    colorPalette: 'gray',
    labelKey: 'page:adminApprovalFlow.mode.unset',
  },
  [ApprovalMode.APPROVAL]: {
    colorPalette: 'blue',
    labelKey: 'page:adminApprovalFlow.mode.approval',
  },
  [ApprovalMode.AUTO]: {
    colorPalette: 'green',
    labelKey: 'page:adminApprovalFlow.mode.auto',
  },
  [ApprovalMode.NO_APPROVAL]: {
    colorPalette: 'gray',
    labelKey: 'page:adminApprovalFlow.mode.noApproval',
  },
}

export const ApprovalModeTag = ({
  mode,
}: {
  mode: ApprovalMode
}): React.ReactElement => {
  const { t } = useTranslation()
  const spec = APPROVAL_MODE_BADGE[mode] ?? APPROVAL_MODE_BADGE[0]
  return (
    <ChakraBadge colorPalette={spec.colorPalette}>
      {t(spec.labelKey)}
    </ChakraBadge>
  )
}
